import RectButton from "../../ui/button/RectButton";
import Input from "../../ui/Input";
// import PaperAirplane from '../../assets/images/paper-airplane.svg';
import * as paperPlaneData from '../../assets/json/lottie/paper-plane.json'
import { ReactComponent as LetterIC } from '../../assets/icons/letter-ic.svg';

import '../SignIn/style.scss';
import './style.scss';
import Modal from "..";
import User from "../../../model/User";
import { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { validate } from "../../../utils";
import ConfirmPopup from '../../Popup/ConfirmPopup';
import Lottie from "react-lottie";

class SignUp extends Component {
    static contextType = AppContext;

    state = {
        name: "",
        lastname: "",
        email: "",
        password: "",
        cpassword: "",
        code: ""
    }

    signUp = () => {
        let result = validate([
            { value: this.state.name },
            { value: this.state.lastname },
            { value: this.state.email },
            { value: this.state.password },
            { value: this.state.cpassword },
            { value: this.state.code },
        ])
        if (result.valid) {
            let { name, lastname, email } = this.state;
            this.context.setUser(new User(1, `${name} ${lastname}`, email));
        }
        else this.context.setPopup(<ConfirmPopup message="Please make sure all fields are filled in correctly" />)
    }

    render() {
        if (this.context.user) {
            return <Redirect to="/" />
        }

        return (
            <>
                <Modal className="signup" relative={this.props.relative}>
                    <h3>Sign Up</h3>
                    <div className="container">
                        <form>
                            <Input name="name" placeHolder="First Name" onChange={(value) => { this.setState({ name: value }) }} />
                            <Input name="lastname" placeHolder="Last Name" onChange={(value) => { this.setState({ lastname: value }) }} />
                            <Input type="email" name="email" placeHolder="Email Address" onChange={(value) => { this.setState({ email: value }) }} />
                            <Input type="password" name="password" placeHolder="Password" onChange={(value) => { this.setState({ password: value }) }} />
                            <Input type="password" name="cpassword" placeHolder="Confirm Password" onChange={(value) => { this.setState({ cpassword: value }) }} />
                            <Input name="code" placeHolder="Signup Code (Optional)" onChange={(value) => { this.setState({ code: value }) }} />
                            <RectButton icon={<LetterIC />} text="SIGN UP" onClick={this.signUp} />
                        </form>
                        <div className="account-ask"><span>Already have an account?</span><Link className="uh" to="/signin">Sign In</Link></div>
                    </div>
                    <div className="paper-airplane">
                        <Lottie options={{
                            loop: false,
                            autoplay: true,
                            animationData: paperPlaneData.default,
                        }}
                            height="100%"
                            width="100%" />
                    </div>
                    {/* <img className="paper-airplane" src={PaperAirplane} alt="Paper Airplane" /> */}
                </Modal>
            </>
        )
    }
}

export default SignUp;